import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { SearchQueryResponse, SearchQueryParams } from "../types/Search";

export const searchQueryKey = (params: SearchQueryParams) =>     [{url:`/api/ms-content-infoportal-backend/v1/mobile/publications_search`},...(params ? [params] : [])] as const;
      export function searchQueryOptions <TData = SearchQueryResponse, TError = unknown>(params: SearchQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = searchQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/mobile/publications_search`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/mobile/publications_search
 */

export function useSearch <TData = SearchQueryResponse, TError = unknown>(params: SearchQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? searchQueryKey(params);

  const query = useQuery<TData, TError>({
    ...searchQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
